/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'camera': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<defs/><g id="icon-photo"><path pid="0" id="Shape" class="cls-1" d="M12.1 6.3h-.9a.5.5 0 0 1 0-1h.9a.47.47 0 0 1 .5.5c-.1.2-.3.5-.5.5zM7.4 2.9H4.7a.47.47 0 0 1-.5-.5c0-.2.3-.4.5-.4h2.7a.47.47 0 0 1 .5.5c0 .3-.2.4-.5.4zm-3.5.5a.47.47 0 0 1 .5.5.54.54 0 0 1-.5.5h-.4A1.54 1.54 0 0 0 2 5.9v5.5A1.56 1.56 0 0 0 3.5 13h9a1.54 1.54 0 0 0 1.5-1.5V5.9a1.54 1.54 0 0 0-1.5-1.5H7.4a.47.47 0 0 1-.5-.5.47.47 0 0 1 .5-.5h5.1A2.48 2.48 0 0 1 15 5.9v5.5a2.48 2.48 0 0 1-2.5 2.5h-9A2.34 2.34 0 0 1 1 11.5V5.9a2.48 2.48 0 0 1 2.5-2.5zm5.3 5.3a2.11 2.11 0 0 1-2.1 2.1A2.05 2.05 0 0 1 5 8.7a2.11 2.11 0 0 1 2.1-2.1 2.18 2.18 0 0 1 2.1 2.1zm-5.1 0a3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3 3.08 3.08 0 0 0-3 3z"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/camera.js